import $ from 'jquery';

const selectLoginTab = (name) => {
	$('.login-panel').addClass('-hide');
	$(`#${name}-login-panel`).removeClass('-hide');
	$('#password-login-button').toggleClass('-hide', name !== 'password');
	$('#microsoft-login-button').toggleClass('-hide', name !== 'entra');
	$('.login-switch').removeClass('-hide');
	$(`#${name}-login-tab`).addClass('-hide');
};

export default selectLoginTab;



// WEBPACK FOOTER //
// ./src/js/index/selectLoginTab.js